import { custom, success } from "./utilities";
import { candidateConstants, globalConstants, screenConstants } from "../../constants";
import { candidateService } from "../../services/candidate.services";
import { ToastifyService } from "../../services/toastify.services";
import { screenService } from "../../services";

const gridData = {
  length: 10,
  pageNumber: 1,
  orderBy: "id desc",
  filterQuery: null,
  search: null,
  filterExpression: globalConstants.FILTER_EXPRESSION
};

export const getColumnsByScreenId = (screenId) => {
  return (dispatch) => {
    dispatch(success([], screenConstants.CLEAR_COLUMNS));
    dispatch(success(true, globalConstants.SPINNER_ACTIVATE));
    screenService
      .getColumnsByScreenId(screenId)
      .then((response) => {
        dispatch(success(response, screenConstants.GET_COLUMNS));
      })
      .catch((error) => ToastifyService.showError(error))
      .finally(() => {
        dispatch(success(false, globalConstants.SPINNER_ACTIVATE));
      });
  };
};

export const getUserPreferencesByScreenId = (screenId) => {
  return (dispatch) => {
    dispatch(success([], screenConstants.CLEAR_COLUMNS));
    dispatch(success(true, globalConstants.SPINNER_ACTIVATE));
    screenService
      .getUserPreferencesByScreenId(screenId)
      .then((response) => {
        dispatch(success(response, screenConstants.GET_PREFERENCES));
      })
      .catch((error) => ToastifyService.showError(error))
      .finally(() => {
        dispatch(success(false, globalConstants.SPINNER_ACTIVATE));
      });
  };
};

export const updateColumnOrderById = (data) => {
  return (dispatch) => {
    dispatch(success(true, globalConstants.SPINNER_ACTIVATE));
    screenService
      .updateColumnOrderById(data)
      .then((response) => {
        // dispatch(getColumnsByScreenId(data.screenId));
        // dispatch(getUserPreferencesByScreenId(data.screenId));
        // ToastifyService.showSuccess(response);
      })
      .catch((error) => ToastifyService.showError(error))
      .finally(() => {
        dispatch(success(false, globalConstants.SPINNER_ACTIVATE));
      });
  };
};

export const updateColumnPreferencesByColumnId = (data) => {
  return (dispatch) => {
    dispatch(success(true, globalConstants.SPINNER_ACTIVATE));
    screenService
      .updateColumnPreferencesByColumnId(data)
      .then((response) => {
        dispatch(getColumnsByScreenId(data.screenId));
        dispatch(getUserPreferencesByScreenId(data.screenId));
        ToastifyService.showSuccess(response);
      })
      .catch((error) => ToastifyService.showError(error))
      .finally(() => {
        dispatch(success(false, globalConstants.SPINNER_ACTIVATE));
      });
  };
};

export const screenActions = {
  getColumnsByScreenId,
  getUserPreferencesByScreenId,
  updateColumnOrderById,
  updateColumnPreferencesByColumnId,
};
